import { Meta, withHeader } from "@impero-com/common/utils/header";
import withI18n, { t } from "@impero-com/common/utils/i18n";
import { Route, Routes } from "react-router-dom";

import { DisabledOrg } from "../anon/disabledOrgPage";

function App() {
    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <>
                        <Meta title={() => t("Login_Title")} />
                        <DisabledOrg />
                    </>
                }
            />
        </Routes>
    );
}

export const AppDisabled = withI18n(withHeader(App));
